/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
e */
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { API_PATH } from "src/environments/config";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UpdateAppointmentProductsService {
  httpWithoutInterceptor: HttpClient;
  constructor(
    private http: HttpClient,
    private router: Router,
    private httpBackend: HttpBackend
  ) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }
  boardProductData = new BehaviorSubject({});
  delBoardProductData = new BehaviorSubject({});
  cartData = new BehaviorSubject([]);
  collectionData = new BehaviorSubject([]);
  appointmentProducts = new BehaviorSubject([]);
  interactiveBoardData = new BehaviorSubject({});
  cartRes = new BehaviorSubject([]);
  consumerCartRes = new BehaviorSubject([]);
  addToCartafterLogin = new BehaviorSubject(false);
  isCartTypes;
  cartTypes;
  wspSequence = 2;
  boardGroupId;
  isRectangularTemplate;
  gradesList;
  userList = new BehaviorSubject([]);
  URL = {
    updateAppointmentPartcipantData: "/updateAppointmentPartcipantData",
    updatePrevAppointmentParticipants: "/updatePrevAppointmentParticipants",
    getCartData: "/cartData",
  };
  prodServerUrl = environment.server;
  updatedProduct = new BehaviorSubject({});
  bussinessUnitSettings: any;

  updateAppointmentProducts(
    code: string,
    products,
    key,
    email?: string,
    isSpotB2B?,
    clickToCall?,
    isOrderPreview?,
    businessUnit?,
    isMultipleUpdate?,
    withoutInterceptor?
  ) {
    var data = {};
    data["code"] = code;
    data[key] = products;
    data["isSpotB2B"] = isSpotB2B;
    data["orderPreview"] = isOrderPreview ? isOrderPreview : undefined;
    if (sessionStorage.getItem("sessionId")) {
      if (sessionStorage.getItem("sessionId").includes("expire")) {
        let sessionObject = JSON.parse(sessionStorage.getItem("sessionId"));
        data["sessionId"] = sessionObject.sessionId;
      } else {
        data["sessionId"] = sessionStorage.getItem("sessionId");
      }
    }
    if (clickToCall) {
      if (!localStorage.getItem("user")) {
        if (this.getParticipantName(code, email))
          data["name"] = this.getParticipantName(code, email);
      } else if (
        isSpotB2B &&
        email &&
        !localStorage.getItem("nVipaniwhiteshopkey") &&
        !localStorage.getItem("retailerToken")
      ) {
        data["email"] = email;
      }
    } else {
      if (email) data["email"] = email;
    }
    if (businessUnit) data["businessUnit"] = businessUnit;
    if (products.classification) {
      if (key === "products") {
        data[key]["classifications"] = [
          { classification: products.classification },
        ];
      } else {
        data["classification"] = products.classification;
      }
    }
    if (products.removeClassification)
      data["removeClassification"] = products.removeClassification;
    if (products.numberOfUnits) data["numberOfUnits"] = products.numberOfUnits;
    if (products.inventoryGroupSet)
      data["inventoryGroupSet"] = products.inventoryGroupSet;
    if (products.inventoriesCount)
      data["inventoriesCount"] = products.inventoriesCount;
    if (isMultipleUpdate) {
      data["isMultipleUpdate"] = true;
    }
    if (products.unitPrice) data["unitPrice"] = products.unitPrice;
    return (withoutInterceptor
      ? this.httpWithoutInterceptor
      : this.http
    ).post<any>(API_PATH.apis.updateAppointmentProducts, data);
  }

  getParticipantName(code, email) {
    if (!localStorage.getItem("retailerToken")) {
      const appointmentsList = localStorage.getItem("appointmentsList")
        ? JSON.parse(localStorage.getItem("appointmentsList"))
        : [];
      const appointmentIndex = appointmentsList.findIndex(
        (eachAppointment) => eachAppointment.code === code
      );
      if (appointmentIndex > -1) return appointmentsList[appointmentIndex].name;
      else return email;
    } else {
      localStorage.removeItem("appointmentsList");
      return email;
    }
  }

  updateAppointmentPartcipantData(code, name, user?, timeTracker?) {
    let httpParams = new HttpParams();
    if (code) {
      httpParams = httpParams.set("code", code);
    }
    if (name) {
      httpParams = httpParams.set("name", name);
    }
    if (user) {
      httpParams = httpParams.set("user", user);
    }
    if (timeTracker) {
      httpParams = httpParams.set("timeTracker", timeTracker);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.updateAppointmentPartcipantData,
      {
        params: httpParams,
      }
    );
  }

  updatePrevAppointmentParticipants(codes) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updatePrevAppointmentParticipants,
      {
        appointmentCodes: codes,
      }
    );
  }

  getCartData(code?, count?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("code", code);
    if (count) {
      httpParams = httpParams.set("count", "true");
    }
    if (!localStorage.getItem("retailerToken")) {
      let appointmentsList = localStorage.getItem("appointmentsList")
        ? JSON.parse(localStorage.getItem("appointmentsList"))
        : [];
      appointmentsList = appointmentsList.forEach((eachAppointment) => {
        if (eachAppointment.code && eachAppointment.name) {
          httpParams = httpParams.append(
            "prevAppointments",
            eachAppointment.code
          );
        }
      });
    } else if (localStorage.getItem("appointmentsList")) {
      localStorage.removeItem("appointmentsList");
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getCartData, {
      params: httpParams,
    });
  }

  updateUserCart(updateData, withoutInterceptor?) {
    if (!localStorage.getItem("retailerToken")) {
      let appointmentsList = localStorage.getItem("appointmentsList")
        ? JSON.parse(localStorage.getItem("appointmentsList"))
        : [];
      if (appointmentsList?.length) {
        updateData["prevAppointments"] = [];
        appointmentsList = appointmentsList.forEach((eachAppointment) => {
          if (eachAppointment.code && eachAppointment.name) {
            updateData.prevAppointments.push(eachAppointment.code);
          }
        });
      }
    } else if (localStorage.getItem("appointmentsList")) {
      localStorage.removeItem("appointmentsList");
    }
    updateData["code"] = updateData.appointmentCode;
    const authToken = localStorage.getItem("nVipaniwhiteshopkey");
    let httpHeader;
    if (authToken) {
      httpHeader = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: authToken,
      });
    }
    return (withoutInterceptor
      ? this.httpWithoutInterceptor
      : this.http
    ).post<any>(API_PATH.apis.updateUserCart, updateData, {
      headers: withoutInterceptor && httpHeader ? httpHeader : undefined,
    });
  }

  updateMultipleOrdersProducts(orders, orderPlaced) {
    var data = {};
    data["orders"] = orders;
    data["orderPlaced"] = orderPlaced;
    return this.http.post<any>(
      API_PATH.apis.updateMultipleOrdersProducts,
      data
    );
  }

  updateUserWishlist() {
    this.http.put(API_PATH.apis.updateUserWishlist, {}).subscribe((res) => {
      console.log(res);
    });
  }

  addProductsToCart(id) {
    let data = { customOrder: id };
    return this.http.post<any>(environment.server + "/addToCart", data);
  }
}
